<template>
    <div class="pin" @mousedown.stop v-if="!hiddenByUser">
        <div class="pin-container">
            <div class="pin-header">
            <router-link :to="{name: 'user', params: {id: pin.author_id}}" class="pin-author">
                <div class="pin-author__avatar" :style="{backgroundImage: 'url(' + getAvatar() +')'}"></div>
                <div class="pin-author__info">
                    <p class="pin-author__name">{{pin.author.nickname}}</p>
                    <p class="pin-author__nick">{{$moment(pin.date).locale('ru').fromNow()}}</p>
                </div>
            </router-link>
            <div class="pin-more" @click="$emit('setSettings', {pin, type: 'pin'})">
                <img src="@/assets/images/icons/more-c.svg">
            </div>
            </div>
            <div class="pin-content" :class="getContentSize(pin.content)" v-if="pin.content && pin.content.length > 0">
                <p v-html="getContent()"></p>
                <p v-if="more" @click="content = true" class="pin-showmore">Еще</p>
            </div>
            <div class="pin-sports" v-if="pin.sports && pin.sports.length > 0">
                <div class="pin-sports__item" 
                    v-for="sport in pin.sports" 
                    :key="sport.id"
                    :class="sport.color + ' color-text'">#{{sport.ru}}</div>
            </div>
            <!-- Media -->
            <div class="pin-media" v-if="pin.media && pin.media.length > 0">
                
                <VueSlickCarousel 
                    v-if="pin.media_type === 'full' && pin.media.length > 1"
                    :dotsClass="'pin-dots'"
                    :arrows="false"
                    :dots="true"
                    :infinite="false">
                    <div class="pin-media__item"
                        v-for="(media, index) in getMedia"
                        :class="media.orientation"
                        :key="index"
                    >
                        <img 
                            @click="showFullPhoto($event, getMedia, index)"
                            :src="media.url" 
                            v-if="media.type === 'image'"
                        >
                        <Video :options="videoOptions(media)" v-else-if="media.type === 'video'" />
                        <p v-else>Неопознанный тип файла</p>
                    </div>
                </VueSlickCarousel>
                <div class="pin-masonry" v-else>
                    <div class="pin-masonry__item" 
                        :class="[getImageClass(getMedia), media.orientation]" 
                        v-for="(media, index) in getMedia"
                        :style="{backgroundImage: `url(${media.url})`}" 
                        :key="index"
                    >
                        <img 
                            @click="showFullPhoto($event, getMedia, index)" 
                            :src="media.url" 
                            v-if="media.type === 'image'"
                        >
                        <Video :options="videoOptions(media)" v-else-if="media.type === 'video'" />
                        <p v-else>Неопознанный тип файла</p>
                    </div>
                </div>
            </div>
            <!-- Иконки: Like, Comment -->
            <div class="pin-panel">
                <div class="pin-panel-general">
                    <div class="pin-item" @click="likeHandler()">
                        <Like 
                            :active="hasLike"
                            :likes="pin.likes"
                            :prompt="true"
                        />
                    </div>
                    <div class="pin-item" @click="comments = !comments">
                        <img src="@/assets/images/icons/lenta/icon_comments.svg">
                        <p class="pin-item__counter" v-if="pin.comments.length > 0">{{pin.comments.length}}</p>
                    </div>
                    <!-- <div class="pin-item" @click="comments = !comments">
                        <img src="@/assets/images/icons/lenta/icon_share.svg" width="29px">
                        <p class="pin-item__counter" v-if="pin.comments.length > 0">{{pin.comments.length}}</p>
                    </div> -->
                </div>
                <div class="pin-panel-info">
                    <div class="pin-item">
                        <img src="@/assets/images/icons/eye.svg">
                        <p>{{pin.views}}</p>
                    </div>
                </div>
            </div>
            <!-- <div class="pin-button"><p>Лайкнули</p></div> -->
            <div class="pin-footer" v-if="pin.comments && pin.comments.length > 0">
                <!-- Комментарии -->
                <div class="pin-comments">
                    <Comment 
                        v-for="comment in getComments" 
                        :comment="comment" 
                        :key="comment.id"
                        @reply="setReply"
                        @setSettings="setSettings"
                    />
                </div>
                <p class="pin-showmore" @click="comments = !comments" v-if="pin.comments.length > 3">{{comments ? 'Скрыть' : 'Показать все'}} комментарии {{ !comments ? `(${pin.comments.length})` : ''}}</p>
            </div>
        </div>
        <div class="pin-adder">
            <div class="pin-adder-wrap">

                <div class="pin-adder__avatar" :style="{backgroundImage: 'url(' + getUserAvatar +')'}">
                </div>
                <input type="text" class="pin-input" :class="'pin-input-' + pin.id" v-model="com_message" :placeholder="reply ? `Ответ пользователю ${reply.author.nickname}:` : 'Добавить комментарий'"  @keydown.enter="inputHandler">
                <!-- <div class="pin-adder-panel__item" @click="smiles = !smiles" >
                    <img src="@/assets/images/icons/smile.svg" width="24px"/>
                    <div class="pin-emoji" v-show="smiles" @click.stop>
                        <VEmojiPicker
                            :emojiSize="24"
                            :emojisByRow="6"
                            :continuousList="true"
                            @select="addSmile"/>
                    </div>
                </div> -->
                <div class="pin-adder-panel__item" @click="sendComment()">
                    <img src="@/assets/images/icons/plane.svg">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// import { VEmojiPicker } from 'v-emoji-picker';
import Video from '@/components/UI/Video.vue';
import 'video.js/dist/video-js.css';

export default {
    name: 'Pin',
    data () {
        return {
            com_message: '',
            comments: false,
            content: false,
            smiles: false,
            reply: null
        }
    },
    props: {
        pin: {
            type: Object,
            required: true
        }
    },
    components: {
        VueSlickCarousel: () => import('vue-slick-carousel'),
        // VEmojiPicker,
        // Participants: () => import('@/components/UI/Participants'),
        Like: () => import ('./Like.vue'),
        Comment: () => import ('./Comment.vue'),
        Video
    },
    computed: {
        hasLike() {
            return this.getUser && this.pin.likes.length > 0 && this.pin.likes.find(like => like && like.author_id === this.getUser.id)
        },
        getUser() {
            return this.$store.getters.getAuthUser
        },
        hiddenByUser() {
            return this.getUser && this.getUser.UnwantedPins 
                ? this.getUser.UnwantedPins.find(pin => pin.id_pin === this.pin.id)
                : false
        },
        getUserAvatar() {
            return this.getUser ? this.getUser.avatar : null
        },
        getComments() {
            let comments = this.pin.comments;
            comments = comments.sort(function(a,b){
                return new Date(a.date) - new Date(b.date);
            });
            let result = [];
            if (comments && comments.length > 0) {
                result = this.comments ? comments : comments.slice(0, 3)
            }
            return result
        },
        getLikedUsers() {
            return this.pin.likes.map(like => like.author)
        },
        more() {
            let result = false;
            let has_media = this.pin.media && this.pin.media.length > 0;
            if (has_media) {
                result = !this.content && this.pin.content.length > 100
            } else {
                result = !this.content && this.pin.content.length > 300
            }
            return result;
        },
        getMedia() {
            let media = this.pin.media;
            return media.sort((a, b) => a.position > b.position ? 1 : -1)
        },
    },
    methods: {
        videoOptions(media) {
            return {
                fluid: true,
                autoplay: false,
                controls: true,
                responsive: true,
                sources: [
                    {
                        src: media.url,
                        type: 'video/mp4'
                    }
                ]
            }
        },
        getAvatar() {
            let avatar = this.pin.author.deleted ? require('@/assets/images/defaults/dead.svg') : this.pin.author.avatar;
            // let result = avatar.indexOf('.webp') != -1 ? avatar.split('.webp')[0] : avatar;
            // return result += '-55x55.webp';
            return avatar;
        },
        setSettings(data) {
            this.$emit('setSettings', data)
        },
        escapeLinks(message) {
            const regexp = new RegExp(/([^"=]{2}|^)((https?|ftp):\/\/\S+[^\s.,> )\];'"!?])/);
            const subst = '$1<a href="$2" target="_blank">$2</a>'; 
            return message.replace(regexp, subst);
        },
        getContent() {
            let result = this.pin.content.replace(/\n/g, '<br>');
            let has_media = this.pin.media && this.pin.media.length > 0;
            if (has_media) {
                result = this.content ? result : this.cutString(result, 100)
            } else {
                result = this.content ? result : this.cutString(result, 300)
            }
            return this.escapeLinks(result);
        },
        setReply(comment) {
            let input = document.querySelector(`.pin-input-${this.pin.id}`);
            input.focus()
            this.reply = comment
        },
        showFullPhoto(event, photos, active) {
            this.$store.dispatch('setPhotos', {photos: photos, active: active})
            this.$store.dispatch('setPhotosState', true)
        },
        cutString (val, length) {
            if (val) {
                val = val.length > length ? val.slice(0, length).concat('...') : val;
            }
            return val
        },
        addSmile(smile) {
            this.com_message += smile.data
        },
        getImageClass(images) {
            let result = '';
            switch (images.length) {
                case 1:
                result = 'size_one';
                break;
                case 2:
                result = 'size_two';
                break;
                case 3:
                result = 'size_tree';
                break;
                case 4:
                result = 'size_four';
                break;
                case 5:
                result = 'size_five';
                break;
                case 6:
                result = 'size_six';
                break;

                default:
                break;
            }
            return result;
        },
        getContentSize(content) {
            let result = null;
            if (content.length < 100) {
                if (this.pin.media.length > 0) {
                    result = 'content_big_media'
                } else {
                    result = 'content_big'
                }
            } else if (content.length < 200) {
                if (this.pin.media.length > 0) {
                    result = 'content_big_media'
                } else {
                    result = 'content_big'
                }
            }
            return result
        },
        inputHandler(e) {
            if (e.keyCode === 13 && !e.shiftKey) {
                e.preventDefault();
                this.sendComment();
            }
        },
        likeHandler() {
            this.hasLike ? this.unLike() : this.sendLike()
        },
        sendLike() {
            let user = {
                id: this.getUser.id,
                firstname: this.getUser.firstname,
                lastname: this.getUser.lastname,
                avatar: this.getUser.avatar,
                nickname: this.getUser.nickname,
            };
            let pin = {
                id: this.pin.id,
                author: this.pin.author,
                content: this.pin.content
            };
            this.$store.dispatch('sendPinLike', {pin})
                .then(like => {
                    if (like[1]) {
                        this.pin.likes.push({
                            author_id: user.id,
                            author: user,
                            date: like[0].date,
                            pin_id: like[0].pin_id
                        })
                    }
                })
                .catch(() => {
                    this.$store.dispatch('addError', {message: 'Произошла ошибка'})
                })
        },
        unLike() {
            let pin = {
                id: this.pin.id
            };
            this.$store.dispatch('sendPinUnLike', {pin})
                .then(like => {
                    if (like) {
                        let index = this.pin.likes.indexOf(this.pin.likes.find(lik => lik.author_id === this.getUser.id));
                        this.pin.likes.splice(index, 1)
                    }
                })
        },
        async sendComment() {
            if (this.com_message && this.com_message.length > 0) {
                let pin = {
                    id: this.pin.id,
                    author: this.pin.author
                };
                let reply = this.reply 
                    ? {
                        id: this.reply.id,
                        author_id: this.reply.author_id
                    } : null;
                let comment = {content: this.com_message.replace(/\n/, '<br>'), pin, reply};
                await this.$axios
                .post(`/api/pins/comment/create`, comment)
                    .then(response => {
                        this.pin.comments.push(response.data)
                        response.data.score 
                            ? this.$store.dispatch('addScore', response.data.score)
                            : ''
                    })
                    .catch((error) => {
                        this.$store.dispatch('addError', {message: error.response.data})
                    });
                this.com_message = ''
                this.reply = null
            }
        },
    }
}
</script>
<style lang="stylus">
.pin
  background var(--blocks)
  border 1px solid var(--blocks-border)
  border-radius 20px
  width 100%
  margin 10px 0
  color var(--text-main)
  position relative
  padding-bottom 65px
  box-shadow var(--blocks-shadow)
  background-color var(--blocks)
  +to-width(540px)
    // margin 0
    // box-shadow none
    // border-radius 0
    border none
    padding-bottom 50px
    // border-bottom 1px solid #eaeaea

  &:hover 
    .pin-panel-info
        opacity 0.5

  &-emoji
    position absolute
    bottom 38px
    right 0px
    background-color white

  &-container
    // max-height 750px
    // overflow-y auto
    position relative

  &-header
    padding 25px 25px
    display flex
    // align-items center
    align-items flex-start
    justify-content space-between
    +to-width(540px)
        padding 15px
        padding-bottom 10px
    
  
  &-sports
    display flex
    padding 3px 25px
    padding-bottom 10px
    text-transform lowercase
    font-size 14px
    +to-width(540px)
        padding 3px 15px

    &__item
        margin-right 5px
        font-weight 500

  &-masonry
    display flex
    flex-wrap wrap
    align-items center
    justify-content center
    width calc(100% + 4px)
    margin 0 -2px

    &__item
    //   border-radius 10px
      margin 2px
      cursor pointer
      overflow hidden
      display flex
      align-items center
      justify-content center
      +to-width(400px)
        border-radius 0
        margin 2px
    
      &.portrait
          img
            max-width 100%
            
      &.landscape
          img
            max-width inherit
            max-height 100%

      &.size_one
        width auto
        margin 0
        // max-height 450px
        &.landscape
          img
            max-width 100%
            max-height 100%
      &.size_two
        width calc(50% - 4px)
        height 300px
        +to-width(640px)
            height 240px
        +to-width(420px)
            height 180px
      &.size_tree
        width calc(50% - 4px)
        max-height 180px
        +to-width(420px)
            max-height 120px
        &:first-child
            width 100%
            max-height 320px
            +to-width(420px)
                max-height 200px
      &.size_four
        width calc(50% - 4px)
        max-height 230px
      &.size_five
        width calc(33.333% - 4px)
        max-height 230px
        &:first-child
          width calc(50% - 4px)
          max-height 300px
        &:nth-child(2)
          width calc(50% - 4px)
          max-height 300px
      &.size_six
        width calc(33.333% - 4px)
        max-height 230px
        +to-width(640px)
            height 180px
        &:first-child
          width 100%
          max-height 300px
          +to-width(640px)
            height 300px
        &:nth-child(2)
          width calc(50% - 4px)
          max-height 300px
        &:nth-child(3)
          width calc(50% - 4px)
          max-height 300px

  &-more
    cursor pointer
    padding 10px
    margin-right -5px
    +to-width(540px)
        margin-top -5px
  
  &-author
    display flex
    align-items center

    &__info
      height 100%
      display flex
      flex-direction column
      justify-content space-between

    &__avatar
      width 42px
      height 42px
      border-radius 50%
      margin-right 15px
      background-size cover
      background-color #f0f0f0
    
    &__name
      font-size 14px
      font-weight 600
      font-style normal
      color var(--text-main)
      padding-bottom 5px
    
    &__nick
      font-size 14px
      color #ACACAC
      font-weight 400
      padding-bottom 5px
      text-transform lowercase
  
  &-content
    font-size 14px
    line-height 22px
    padding 10px 25px
    padding-top 0
    +to-width(540px)
        padding 10px 15px
        padding-top 0
    a
      color black
      text-transform lowercase
      font-weight 500
    
    &.content_big
        font-size 22px
        line-height 28px
        &_media
            font-size 18px
        +to-width(420px)
            font-size 18px
  
  &-media
    overflow hidden
    position relative
    display flex
    align-items center
    background-color var(--blocks)
    padding-bottom 10px
    div
        width calc(100% + 4px)
        .video-js .vjs-big-play-button
            // border 1px solid white
            // background-color rgba(255,255,255,0.5)
            border none
            background-color transparent !important
            left calc(50% - 45px)
            top calc(50% - 25px)
        .video-js .vjs-big-play-button .vjs-icon-placeholder:before
            // color black
            font-size 80px

    .slick-slider
        width 100%
        // height 490px
        overflow hidden
        img
            pointer-events none
    .slick-track
        // height 100%
        // max-height 600px
    
    .pin-dots
        position absolute
        bottom 25px
        left 0
        right 0
        display flex !important
        justify-content center
        align-items center
        li
            color transparent
            border-radius 50%
            width 10px
            height 10px
            background-color white
            opacity 0.5
            margin 0 5px
            button
                opacity 0
                width 100%
                height 100%
            &.slick-active
                opacity 1
    &__item
        height 100%
        max-height 60vh
        display flex !important
        align-items center
        justify-content center
        overflow hidden
        img
            max-width 100%
            // min-height 100%
        &.landscape
            img
                max-width inherit
                max-height 550px
  
  &-item
    font-size 28px
    margin-right 18px
    display flex
    align-items center
    cursor pointer

    &__counter
      font-size 16px
      font-weight 400
      padding-left 7px

    &:hover
      path
        fill black

  &-showmore
    margin-top 10px
    font-size 14px
    font-weight 400
    color #A3A3A3
    cursor pointer

  &-panel
    display flex
    align-items center
    justify-content space-between
    padding 18px 25px
    padding-top 10px
    +to-width(540px)
        padding 18px 15px
        padding-top 10px

    &-general
        display flex
        align-items center
    
    &-info
        opacity 0
        transition 0.3s all
        .pin-item
            margin 0
        p
            font-size 16px
            font-weight 500
            margin-left 5px

  &-adder
    margin-top 18px
    position absolute
    bottom 0
    padding 10px 25px
    padding-bottom 20px
    left 0
    right 0
    +to-width(540px)
        padding 10px 15px
    &__avatar
      min-width 30px
      width 30px
      height 30px
      border-radius 50%
      margin-right 15px
      background-size cover
    
    &-wrap
        display flex
        align-items center

    &-reply
        font-weight 500
        padding-left 45px

    &-panel
        &__item
            position relative
            padding 5px
            margin-left 5px
            img
                transition 0.3s all
                cursor pointer
            &:hover
                img
                    opacity 0.7

  &-input
    box-shadow none
    border none
    font-size 14px
    background transparent
    width 100%

  &-footer
    padding 0 25px
    padding-bottom 10px
    position relative
    +to-width(540px)
        padding 0 15px
</style>